var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { errorHandler } from "../../../helpers";
export var useGetInstagramImages = function () {
    return function (client, query, library_uuid, callback, onError) { return __awaiter(void 0, void 0, void 0, function () {
        var data, images, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, client.query({
                            query: query,
                            variables: {
                                library_uuid: library_uuid,
                            },
                        })];
                case 1:
                    data = (_a.sent()).data;
                    if (data === null || data === void 0 ? void 0 : data.getInstagramImages) {
                        images = data === null || data === void 0 ? void 0 : data.getInstagramImages;
                        response = __assign(__assign({}, data === null || data === void 0 ? void 0 : data.getInstagramImages), { images: images.map(function (image) { return ({ url: image }); }) });
                        callback === null || callback === void 0 ? void 0 : callback(response);
                    }
                    return [2 /*return*/, []];
                case 2:
                    error_1 = _a.sent();
                    onError === null || onError === void 0 ? void 0 : onError();
                    return [2 /*return*/, []];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var useGetLibraryImages = function () {
    return function (client, query, variables, callback, onError) { return __awaiter(void 0, void 0, void 0, function () {
        var data, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log(variables);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, client.query({
                            query: query,
                            variables: variables,
                            fetchPolicy: "network-only"
                        })];
                case 2:
                    data = (_a.sent()).data;
                    (data === null || data === void 0 ? void 0 : data.getImagesByLibraryUuid) && (callback === null || callback === void 0 ? void 0 : callback(data === null || data === void 0 ? void 0 : data.getImagesByLibraryUuid));
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    errorHandler(error_2);
                    onError === null || onError === void 0 ? void 0 : onError();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var useGetUnsplashImages = function () {
    return function (client, query, variables, callback, onError) { return __awaiter(void 0, void 0, void 0, function () {
        var data, images, response, error_3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(variables === null || variables === void 0 ? void 0 : variables.search))
                        variables === null || variables === void 0 ? true : delete variables.search;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, client.query({
                            query: query,
                            variables: variables,
                        })];
                case 2:
                    data = (_b.sent()).data;
                    if (data === null || data === void 0 ? void 0 : data.getUnsplashImages) {
                        images = (_a = data === null || data === void 0 ? void 0 : data.getUnsplashImages) === null || _a === void 0 ? void 0 : _a.images;
                        response = __assign(__assign({}, data === null || data === void 0 ? void 0 : data.getUnsplashImages), { images: images.map(function (image) { return (__assign(__assign({}, image), { source: "https://unsplash.com" })); }) });
                        callback === null || callback === void 0 ? void 0 : callback(response);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _b.sent();
                    errorHandler(error_3);
                    onError === null || onError === void 0 ? void 0 : onError();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var useGetPexelsImages = function () {
    return function (client, query, variables, callback, onError) { return __awaiter(void 0, void 0, void 0, function () {
        var data, images, response, error_4;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(variables === null || variables === void 0 ? void 0 : variables.search))
                        variables === null || variables === void 0 ? true : delete variables.search;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, client.query({
                            query: query,
                            variables: variables,
                        })];
                case 2:
                    data = (_b.sent()).data;
                    if (data === null || data === void 0 ? void 0 : data.getPexelsImages) {
                        images = (_a = data === null || data === void 0 ? void 0 : data.getPexelsImages) === null || _a === void 0 ? void 0 : _a.images;
                        response = __assign(__assign({}, data === null || data === void 0 ? void 0 : data.getPexelsImages), { images: images.map(function (image) { return (__assign(__assign({}, image), { source: "https://pexels.com" })); }) });
                        callback === null || callback === void 0 ? void 0 : callback(response);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_4 = _b.sent();
                    errorHandler(error_4);
                    onError === null || onError === void 0 ? void 0 : onError();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
